import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
import RawStock from './components/RawStock';
import Restock from './components/Restock';
import Formulas from './components/Formulas';
import Production from './components/Production';
import Bottling from './components/Bottling';
import { BulkStock, FinishedStock, Adjust, Audit, Setup } from './components/OtherPages';
import './styles/global.css';

function AppInner() {
  const { user, loading } = useAuth();
  const [page, setPage] = useState('dashboard');

  if (loading) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#0f0c29', color:'rgba(255,255,255,.4)', fontSize:13 }}>
      กำลังโหลด...
    </div>
  );
  if (!user) return <Login/>;

  const renderPage = () => {
    switch (page) {
      case 'dashboard':     return <Dashboard/>;
      case 'raw-stock':     return <RawStock/>;
      case 'restock':       return <Restock/>;
      case 'bulk-stock':    return <BulkStock/>;
      case 'finished-stock':return <FinishedStock/>;
      case 'adjust':        return <Adjust/>;
      case 'formulas':      return <Formulas/>;
      case 'production':    return <Production setPage={setPage}/>;
      case 'bottling':      return <Bottling setPage={setPage}/>;
      case 'users':         return <Users/>;
      case 'setup':         return <Setup/>;
      case 'audit':         return <Audit/>;
      default:              return <Dashboard/>;
    }
  };

  return (
    <Layout page={page} setPage={setPage}>
      {renderPage()}
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner/>
    </AuthProvider>
  );
}
